var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashProd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlashProd_svg__a",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    rx: 10.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10.667,
    fill: "#E74536"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "FlashProd_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlashProd_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlashProd_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.25 5.75)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0F1941",
    cx: 28.667,
    cy: 28,
    r: 24.667
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F5F0",
    cx: 24.667,
    cy: 24.667,
    r: 24.667
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.622 21.958h-3.368l3.784-18.071c.355-1.693-1.928-2.618-2.884-1.17L14.656 26.184c-.687 1.04.07 2.418 1.33 2.418h2.68L13.428 42.76c-.543 1.469 1.378 2.591 2.425 1.417l17.802-19.968c.781-.876.15-2.25-1.033-2.25z",
    fill: "#FFB511"
  }))))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPGRlZnM+CiAgICAgICAgPHJlY3QgaWQ9ImEiIHg9IjAiIHk9IjAiIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgcng9IjEwLjY2NyIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8cmVjdCB3aWR0aD0iNjQiIGhlaWdodD0iNjQiIHJ4PSIxMC42NjciIGZpbGw9IiNFNzQ1MzYiLz4KICAgICAgICA8bWFzayBpZD0iYiIgZmlsbD0iI2ZmZiI+CiAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2EiLz4KICAgICAgICA8L21hc2s+CiAgICAgICAgPGcgbWFzaz0idXJsKCNiKSI+CiAgICAgICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDUuMjUgNS43NSkiPgogICAgICAgICAgICAgICAgPGNpcmNsZSBmaWxsPSIjMEYxOTQxIiBjeD0iMjguNjY3IiBjeT0iMjgiIHI9IjI0LjY2NyIvPgogICAgICAgICAgICAgICAgPGNpcmNsZSBmaWxsPSIjRjdGNUYwIiBjeD0iMjQuNjY3IiBjeT0iMjQuNjY3IiByPSIyNC42NjciLz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0zMi42MjIgMjEuOTU4aC0zLjM2OGwzLjc4NC0xOC4wNzFjLjM1NS0xLjY5My0xLjkyOC0yLjYxOC0yLjg4NC0xLjE3TDE0LjY1NiAyNi4xODRjLS42ODcgMS4wNC4wNyAyLjQxOCAxLjMzIDIuNDE4aDIuNjhMMTMuNDI4IDQyLjc2Yy0uNTQzIDEuNDY5IDEuMzc4IDIuNTkxIDIuNDI1IDEuNDE3bDE3LjgwMi0xOS45NjhjLjc4MS0uODc2LjE1LTIuMjUtMS4wMzMtMi4yNXoiIGZpbGw9IiNGRkI1MTEiLz4KICAgICAgICAgICAgPC9nPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";
export { SvgFlashProd as ReactComponent };